import {useLocale} from "../../hooks/use-locale";
import tripDatabase from "../../generated/trip-database.json";
import {Typography} from "@mui/material";
import {useDispatch} from "../../store";
import {useTranslation} from "next-i18next";
import {useForex} from "../../hooks/use-forex";
import {Link} from "../link"

interface OfferLinkProps {
    title: string;
    tripId: string;
}

// <a href='{{ ($.Site.GetPage (.Get "trip-id")).Permalink }}'>{{.Get "title"}}</a>{{- with $.Site.GetPage (.Get "trip-id") }} <span style="font-size: smaller;font-weight: bold">({{ .Params.offer }} {{ i18n "starting-from" }} <span class='sc_price' data-trip-id='{{ $.Get "trip-id" }}'>...</span>)</span>{{- end -}}

export function OfferLink({title, tripId}: OfferLinkProps) {
    const locale = useLocale()

    const {t} = useTranslation();

    const {convertCurrency} = useForex()

    const dispatch = useDispatch()

    const tripData = tripDatabase[tripId as keyof typeof tripDatabase];
    const slugs = tripData?.slugs[locale === "fr" ? "fr" : "en"]
    // @ts-ignore
    const offer = tripData?.offering[locale === "fr" ? "fr" : "en"]?.offer ?? ""
    const offerLowUSD = tripData?.offerLowUSD ?? ""

    return <>
        {tripData && <>
            <Link href={{
                pathname: "/diving/[countrySlug]/[tripSlug]",
                query: {countrySlug: slugs.countrySlug, tripSlug: slugs.tripSlug}
            }}
            >{title}</Link>
            <Typography variant={"subtitle2"} component={"span"} display={"inline"}> ({offer} {t("starting-from")} {" "}
                {convertCurrency(offerLowUSD, "USD")})</Typography>
        </>}

        {!tripData && <>
            <Typography variant={"subtitle2"} component={"span"} display={"inline"}
                        color={"#f00"}>ERROR: {tripId}</Typography>
        </>}

    </>;
}
